<template>
  <div class="app-container">
    <!-- 搜索条件 -->
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="用电订单编号">
        <el-input placeholder="请输入用电订单编号" v-model="filter.use_elec_order_no" clearable></el-input>
      </el-form-item>
      <el-form-item label="分账编号">
        <el-input placeholder="请输入分账编号" v-model="filter.sharing_no" clearable></el-input>
      </el-form-item>
      <el-form-item label="商户名称">
        <el-input placeholder="请输入商户名称" v-model="filter.merchant_name" clearable></el-input>
      </el-form-item>
      <el-form-item label="站点名称">
        <el-input placeholder="请输入站点名称" v-model="filter.site_name" clearable></el-input>
      </el-form-item>
      <el-form-item label="结算状态">
        <el-select class="selScale" v-model="filter.settle_status" style="width: 130px">
          <el-option label="--全部--" value=""></el-option>
          <el-option label="已结算" value="1"></el-option>
          <el-option label="未结算" value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="创建时间">
        <el-date-picker
          v-model="filter.dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>

    <!-- 分账列表 -->
    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading" highlight-current-row>
      <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
      <el-table-column label="用电订单编号" prop="PayOrderCode" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="分账编号" prop="PayOrderSaccCode" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="用电金额" align="right" width="100">
        <template slot-scope="{ row }">{{ formatAmount(row.OrderAmount) }}</template>
      </el-table-column>
      <el-table-column label="分账金额" align="right" width="100">
        <template slot-scope="{ row }">
          <span class="sharing-amount">{{ formatAmount(row.SaccAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="分账比例" align="center" width="100">
        <template slot-scope="{ row }">{{ formatRatio(row.SaccRete) }}</template>
      </el-table-column>
      <el-table-column label="所属站点" prop="site_name" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="商户名称" prop="merchant_name" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="分账收款方编号" prop="SaccPayeeCode" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="分账收款方名称" prop="SaccPayeeName" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="结算状态" align="center" width="100">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="isSettled(row) ? 'success' : 'info'">{{ settleStatusText(row) }}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="结算单编号" align="center" width="100">
        <template slot-scope="{ row }">
          {{row.SaccSetteOrder_ID > 0 ? row.SaccSetteOrder_ID : ''}}
        </template>
      </el-table-column> -->
      <el-table-column label="创建时间" prop="CreateTime" width="170" align="center"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="90" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <!-- 当前搜索条件下的分账金额汇总 -->
      <div class="statistic_left">
        <span class="sbox">
          总分账金额：<span class="bold ssuc">{{ formatAmount(totalSharingAmount) }} 元</span>
        </span>
      </div>
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 分账详情 Drawer（只读） -->
    <el-drawer
      title="分账详情"
      :visible.sync="visible.detail"
      direction="rtl"
      :size="drawerSize"
      @closed="onDetailClosed"
    >
      <div class="drawer-container">
        <div class="drawer-body" v-loading="detailLoading">
          <el-descriptions :column="2" border size="small" class="detail-desc">
            <el-descriptions-item label="用电订单编号">{{ detailData.PayOrderCode || "-" }}</el-descriptions-item>
            <el-descriptions-item label="分账编号">{{ detailData.PayOrderSaccCode || "-" }}</el-descriptions-item>
            <el-descriptions-item label="用电订单总金额（元）">
              {{ formatAmount(detailData.OrderAmount) }}
            </el-descriptions-item>
            <el-descriptions-item label="分账金额（元）">
              <span class="sharing-amount">{{ formatAmount(detailData.SaccAmount) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="分账比例">{{ formatRatio(detailData.SaccRete) }}</el-descriptions-item>
            <el-descriptions-item label="商户名称">{{ detailData.merchant_name || "-" }}</el-descriptions-item>
            <el-descriptions-item label="分账收款方编号">{{ detailData.SaccPayeeCode || "-" }}</el-descriptions-item>
            <el-descriptions-item label="分账收款方名称">{{ detailData.SaccPayeeName || "-" }}</el-descriptions-item>
            <el-descriptions-item label="结算状态">
              <el-tag size="small" :type="isSettled(detailData) ? 'success' : 'info'">
                {{ settleStatusText(detailData) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="用电电量（度）">{{ formatNumber(detailData.order_totalElect) }}</el-descriptions-item>
            <el-descriptions-item label="用电订单电费（元）">
              {{ formatAmount(detailData.order_totalPowerCost) }}
            </el-descriptions-item>
            <el-descriptions-item label="用电订单服务费（元）">
              {{ formatAmount(detailData.order_totalServCost) }}
            </el-descriptions-item>
            <el-descriptions-item label="所属站点">{{ detailData.site_name || "-" }}</el-descriptions-item>
            <el-descriptions-item label="分支箱名称">{{ detailData.branch_box_name || "-" }}</el-descriptions-item>
            <el-descriptions-item label="分支箱资产码">{{ detailData.assets_code || "-" }}</el-descriptions-item>
            <el-descriptions-item label="通道">{{ detailData.order_gun_no != null ? detailData.order_gun_no : "-" }}</el-descriptions-item>
            <!-- 已结算才展示结算单号与分账收款方编号 -->
            <!-- <template v-if="isSettled(detailData)">
              <el-descriptions-item label="分账结算单号">{{ detailData.settle_order_no || "-" }}</el-descriptions-item>
              <el-descriptions-item label="分账收款方编号">{{ detailData.payee_no || "-" }}</el-descriptions-item>
            </template> -->
            <el-descriptions-item label="创建时间">{{ detailData.CreateTime || "-" }}</el-descriptions-item>
            <el-descriptions-item label="更新时间">{{ detailData.UpdateTime || "-" }}</el-descriptions-item>
            <el-descriptions-item label="备注" :span="2">{{ detailData.Remark || "-" }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="drawer-footer">
          <el-button type="primary" @click="visible.detail = false">关闭</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { GetUseElecSharingPageList, getUseElecSharingStatisticApi, GetUseElecSharingDetail } from "@/api/finance"

export default {
  name: "UseElecRevenueSharing",
  mixins: [pageMixin],
  data() {
    return {
      tableData: [],
      loading: false,
      // 当前搜索条件下的总分账金额
      totalSharingAmount: 0,
      filter: {
        use_elec_order_no: "",
        sharing_no: "",
        merchant_name: "",
        site_name: "",
        settle_status: "",
        dateRange: []
      },
      visible: {
        detail: false
      },
      drawerSize: "50%",
      detailLoading: false,
      detailData: {}
    }
  },
  created() {
    this.getData()
  },
  methods: {
    buildParams() {
      const [start_time, end_time] =
        this.filter.dateRange && this.filter.dateRange.length === 2 ? this.filter.dateRange : ["", ""]
      return {
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        use_elec_order_no: this.filter.use_elec_order_no || null,
        sharing_no: this.filter.sharing_no || null,
        merchant_name: this.filter.merchant_name || null,
        site_name: this.filter.site_name || null,
        settle_status: this.filter.settle_status === "" ? null : this.filter.settle_status,
        start_time: start_time || null,
        end_time: end_time || null
      }
    },

    getData() {
      this.loading = true
      GetUseElecSharingPageList(this.buildParams())
        .then((res) => {
          this.tableData = (res && res.data) || []
          this.pageParams.total = (res && (res.total || res.count)) || 0
        })
        .catch(() => {
          this.tableData = []
          this.pageParams.total = 0
        })
        .finally(() => {
          this.loading = false
        })
      // 没当访问第一页数据时，调用一下统计数据的接口
      if(this.pageParams.page === 1){
        getUseElecSharingStatisticApi(this.buildParams())
          .then((res) => {
            this.totalSharingAmount = (res && res.TotalSaccAmount) || 0
          })
          .catch(() => {
            this.totalSharingAmount = 0
          })
          .finally(() => {
            
          })
      }
    },

    /* ============ 详情 ============ */
    onDetail(row) {
      this.detailData = { ...row }
      this.drawerSize = this.calcDrawerSize()
      this.visible.detail = true
      this.fetchDetail(row)
    },

    fetchDetail(row) {
      this.detailLoading = true
      GetUseElecSharingDetail({ Id: row.ID})
        .then((res) => {
          const detail = res && res.outputData ? res.outputData : {}
          this.detailData = { ...row, ...detail }
        })
        .catch(() => {
          // 服务端接口暂未实现，使用列表行数据回显，保证前端可正常联调
          this.detailData = { ...row }
        })
        .finally(() => {
          this.detailLoading = false
        })
    },

    onDetailClosed() {
      this.detailData = {}
      this.detailLoading = false
    },

    // Drawer 宽度 = 内容界面宽度的 50%
    calcDrawerSize() {
      const contentWidth = (this.$el && this.$el.clientWidth) || window.innerWidth
      return Math.max(Math.floor(contentWidth * 0.5), 320) + "px"
    },

    /* ============ 展示格式化 ============ */
    isSettled(row) {
      if (!row) return false
      if (row.SaccSetteOrder_ID > 0) return true
      return false
    },

    settleStatusText(row) {
      if (!row) return "-"
      //if (row.settle_status_name) return row.settle_status_name
      return this.isSettled(row) ? "已结算" : "未结算"
    },

    formatAmount(val) {
      if (val === null || val === undefined || val === "") return "0.00"
      const num = Number(val)
      if (isNaN(num)) return val
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatRatio(val) {
      if (val === null || val === undefined || val === "") return "-"
      const num = Number(val)
      if (isNaN(num)) return val
      return `${parseFloat(num.toFixed(2))*100}%`
    },

    formatNumber(val) {
      if (val === null || val === undefined || val === "") return "0"
      const num = Number(val)
      if (isNaN(num)) return val
      return parseFloat(num.toFixed(2))
    }
  }
}
</script>

<style scoped>
.sharing-amount {
  color: #f56c6c;
  font-weight: 600;
}

.drawer-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.drawer-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 20px;
}

.drawer-footer {
  flex-shrink: 0;
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.detail-desc {
  margin-bottom: 12px;
}

::v-deep .el-drawer__body {
  overflow: hidden;
}
</style>
